// extracted by mini-css-extract-plugin
export default {"page_wrap":"JobPost_page_wrap__Ug3ag"};